module.exports = __webpack_public_path__ + "img/19.dd003a38.jpg";